<template>
  <div class="container">
    <!-- 加载中 -->
    <div v-if="loading" class="loading-wrap">
      <div class="spinner"></div>
      <p>正在检测支付环境...</p>
    </div>

    <!-- 错误提示 -->
    <div v-else-if="error" class="error-wrap">
      <div class="error-icon">!</div>
      <p class="error-title">{{ errorTitle }}</p>
      <p class="error-desc">{{ errorDesc }}</p>
    </div>

    <!-- 第三方环境引导页 -->
    <div v-else-if="showGuide" class="guide-wrap">
      <div class="guide-header">
        <div class="guide-icon">
          <div class="img">
            <img style="width: 108px; height: 100px" :src="failIconUrl" fit="contain" />
          </div>
        </div>
        <h2>推荐使用支付宝或微信扫码</h2>
        <p class="guide-subtitle">当前环境不支持自动收款，请选择以下方式</p>
      </div>

      <div class="guide-amount">¥{{ orderInfoPrice || '--' }}</div>

      <div class="guide-buttons">
        <div @click="openAlipay" class="btn btn-alipay">
          打开支付宝收款
        </div>
        <div @click="openWechat" class="btn btn-wechat">
          打开微信收款
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderByorderID } from "@/api/index"

export default {
  name: "UnifiedPay",
  data() {
    return {
      orderId: null,
      orderInfoPrice: 0,
      loading: true,
      error: false,
      errorTitle: '',
      errorDesc: '',
      showGuide: false,
      failIconUrl: require('@/assets/fail.png'),
    }
  },
  async created() {
    document.title = '收款';
    this.orderId = this.$route.query.orderId
    if (!this.orderId) {
      this.showError('缺少订单信息', '请重新扫描收款码')
      return
    }
    // 获取订单金额（用于引导页展示）
    try {
      const res = await getOrderByorderID(this.orderId)
      this.orderInfoPrice = res.data.data
    } catch (e) {
      // 查询失败不影响跳转，引导页展示 0
    }
    this.detectAndRoute()
  },
  methods: {
    detectAndRoute() {
      const ua = navigator.userAgent.toLowerCase()
      // 构造正确的基础路径（兼容子目录部署）
      const basePath = window.location.href.split('#')[0]

      // 支付宝客户端环境
      if (ua.indexOf('alipayclient') > -1) {
        window.location.href = basePath + '#/auth_token?orderId=' + this.orderId
        return
      }

      // 微信客户端环境
      if (ua.indexOf('micromessenger') > -1) {
        window.location.href = basePath + '#/wechat_pay?orderId=' + this.orderId
        return
      }

      // 其他环境 → 显示引导页
      this.loading = false
      this.showGuide = true
    },

    openAlipay() {
      const basePath = window.location.href.split('#')[0]
      const targetUrl = encodeURIComponent(
        basePath + '#/auth_token?orderId=' + this.orderId
      )
      const appScheme = 'alipays://platformapi/startapp?appId=20000067&url=' + targetUrl
      this.tryOpenApp(appScheme, 'alipay')
    },

    openWechat() {
      const basePath = window.location.href.split('#')[0]
      const targetUrl = encodeURIComponent(
        basePath + '#/wechat_pay?orderId=' + this.orderId
      )
      // 微信URL Scheme（部分微信版本支持）
      const appScheme = 'weixin://'
      this.tryOpenApp(appScheme, 'wechat')
    },

    tryOpenApp(scheme, appName) {
      const downloadUrl = {
        alipay: {
          ios: 'https://apps.apple.com/cn/app/alipay/id333206289',
          android: 'market://details?id=com.eg.android.AlipayGphone'
        },
        wechat: {
          ios: 'https://apps.apple.com/cn/app/wechat/id414478124',
          android: 'market://details?id=com.tencent.mm'
        }
      }

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = scheme
        document.body.appendChild(iframe)
        setTimeout(() => {
          document.body.removeChild(iframe)
          if (!document.hidden) {
            window.location.href = downloadUrl[appName].ios
          }
        }, 1000)
      } else {
        try {
          window.location.href = scheme
          setTimeout(() => {
            if (!document.hidden) {
              window.location.href = downloadUrl[appName].android
            }
          }, 2000)
        } catch (e) {
          window.location.href = downloadUrl[appName].android
        }
      }
    },

    showError(title, desc) {
      this.loading = false
      this.error = true
      this.errorTitle = title
      this.errorDesc = desc
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.loading-wrap {
  text-align: center;
  color: #999;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1677FF;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.error-wrap {
  text-align: center;
  padding: 40px 20px;
}

.error-icon {
  width: 48px;
  height: 48px;
  background: #FFF0F0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
  color: #FB332A;
  font-weight: bold;
}

.error-title {
  font-size: 18px;
  color: #333;
  margin: 0 0 8px;
}

.error-desc {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.guide-wrap {
  width: 100%;
  max-width: 360px;
  padding: 40px 24px;
  text-align: center;
}

.guide-header {
  margin-bottom: 24px;
}

.guide-icon {
  margin-bottom: 12px;
}

.guide-header h2 {
  font-size: 20px;
  color: #333;
  margin: 0 0 8px;
  font-weight: 500;
}

.guide-subtitle {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.guide-amount {
  font-size: 36px;
  color: #FF5946;
  font-weight: 400;
  margin-bottom: 32px;
}

.guide-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn {
  height: 44px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn:active {
  opacity: 0.8;
}

.btn-alipay {
  background: #1677FF;
  color: #fff;
}

.btn-wechat {
  background: #07C160;
  color: #fff;
}
</style>
